import { removeStorageItems } from "@/utils/storage/storage-utils";

const DEPRECATED_STORAGE_PREDICATES: ((key: string) => boolean)[] = [
  (key) =>
    [
      "currentAccountId",
      "recent-opened-models",
      "currentModelMode",
      "sidebarItemSettings",
      "historySidebarState",
      "isDarkModeEnabled",
      "weld-current-tab",
      "weld-tabs",
      "weld:essential-plan-discontinuation-banner",
      "weld:essential-plan-discontinuation-dialog",
    ].includes(key),
  (key) => key.startsWith("weld:model-tool:recently-opened-models:"),
];

export function removedDeprecatedStorageItems() {
  removeStorageItems(DEPRECATED_STORAGE_PREDICATES);
}
